import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { H3 } from '../../styled/typograpghy.styled';
import { FlexContainer } from '../../styled/layout.styled';
import apiClient from '../../../helpers/apiClient';
import toastNotify from '../../utils/toastNotify';

const StyledH3 = styled(H3)`
  margin: 0 0 16px 0;

  @media only screen and (max-width: 568px) {
    margin: 0 0 16px 0;
    font-size: 20px;
  }
`;

const StyledP = styled.p`
  width: 420px;
  text-align: center;
  margin: 0 0 24px 0;
  color: ${({ theme }) => theme.color.white};
  @media only screen and (max-width: 568px) {
    width: 312px;
  }
`;

const StyledSource = styled.a`
  color: #ff2976;
  cursor: pointer;
`;

const StyledSpan = styled.span`
  @media only screen and (max-width: 568px) {
    display: none;
  }
`;

const EmailVerificationAndExpiration = ({ title, span, description }) => {
  const email = useSelector(state => state.affiliate.email);

  const handleOnClickResendEmail = () => {
    apiClient()
      .post('/affiliate/auth/resend', { referrer_email: email })
      .then(toastNotify('Email sent successfully', 2000))
      .catch(e => console.log(e));
  };
  return (
    <>
      <FlexContainer padding="70px 0 366px 0" justifyContent="center" mobilePadding="40px 0 539px 0">
        <FlexContainer flexDirection="column" alignItems="center">
          <StyledH3>{title}</StyledH3>
          <StyledP>
            {span && <StyledSpan>{span}</StyledSpan>}
            {description}
          </StyledP>
          <StyledSource className="small" onClick={() => handleOnClickResendEmail()}>
            Resend Email
          </StyledSource>
        </FlexContainer>
      </FlexContainer>
    </>
  );
};

EmailVerificationAndExpiration.propTypes = {
  title: PropTypes.string.isRequired,
  span: PropTypes.string,
  description: PropTypes.string.isRequired,
};

EmailVerificationAndExpiration.defaultProps = {
  span: '',
};
export default EmailVerificationAndExpiration;
